module.exports = __webpack_public_path__ + "fonts/manrope-medium.140378ca.woff";